import React from 'react'
import InputColor from '../../../components/Input/InputColor'
import { Container, Content, Title } from './styles'

export interface InputColorContentProps {
  control: any
}

const InputColorContent: React.FunctionComponent<InputColorContentProps> = ({ control }) => {
  return (
    <Container>
      <Title>Paleta de Cores</Title>
      <Content>
        <InputColor control={control} name='primaryColor' label='Primária' />
        <InputColor control={control} name='secondaryColor' label='Secundária' />
      </Content>
    </Container>
  )
}

export default InputColorContent
